import React, { useEffect, useState } from 'react';

import { Unauthorized } from '../../api-client';
import { Content, Footer, Loader, Main, ModalContainer, ScrollToTopButton } from '../../components';
import { Header } from '../../components/layout';
import { HeaderPublic } from '../../components/layout/HeaderNew';
import Overlay from '../../components/layout/Overlay';
import { createAuthTokenManager, createAuthTokenStorage, createProfileManager } from '../../di';
import { useAppDispatch, useLoggedInStatus } from '../../hooks';
import { set } from '../../store/profile';
import { AuthTokenExpired, ChildrenProps } from '../../utils';

const LayoutPublic = ({ children }: ChildrenProps) => {
  const dispatch = useAppDispatch();
  const profileLoaded = useLoggedInStatus();
  const [hasSession, setHasSession] = useState(() => createAuthTokenStorage().get() !== null);

  useEffect(() => {
    if (!hasSession || profileLoaded) {
      return;
    }
    let cancelled = false;
    (async () => {
      try {
        const manager = await createProfileManager();
        const profile = await manager.get();
        if (!cancelled) {
          dispatch(set(profile));
        }
      } catch (error) {
        if (cancelled) {
          return;
        }
        // Публичные страницы доступны без входа, поэтому истёкшая сессия не уводит
        // на форму авторизации — просто показываем шапку для гостя.
        if (error instanceof Unauthorized || error instanceof AuthTokenExpired) {
          createAuthTokenManager().remove();
        }
        setHasSession(false);
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [hasSession, profileLoaded]);

  if (hasSession && !profileLoaded) {
    return (
      <Content>
        <Loader />
      </Content>
    );
  }

  return (
    <Content>
      {profileLoaded ? <Header /> : <HeaderPublic />}
      <Overlay />
      <Main cabinet={profileLoaded}>{children}</Main>
      <Footer />
      <ModalContainer />
      <ScrollToTopButton />
    </Content>
  );
};

export default LayoutPublic;
